export default __webpack_public_path__ + "static/media/vid1.df78180b.mp4";